import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "graph-div" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"legend-container\"><div class=\"legend-row\"><div class=\"legend-item\"><div class=\"legend-color finished\"></div><span>Finalizado</span></div><div class=\"legend-item\"><div class=\"legend-color waiting\"></div><span>Aguardando</span></div><div class=\"legend-item\"><div class=\"legend-color running\"></div><span>Em andamento</span></div></div><div class=\"legend-row\"><div class=\"legend-item\"><div class=\"legend-color interrupted\"></div><span>Interrompido</span></div><div class=\"legend-item\"><div class=\"legend-color canceled\"></div><span>Cancelado</span></div></div></div>", 1)

import Vue3ChartJs from '@j-t-mcc/vue3-chartjs';
import { onMounted, ref, watch } from 'vue';
import { IDataset } from '../../types';

interface IProps {
  data: IDataset;
}
const secondaryFinished = "#00B88D";
const secondaryWaiting = "#697B8E";
const secondaryRunning = "#0095FF";
const secondaryCanceled = "#FFAA00";
const secondaryInterrupted = "#D04B00";


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomChartPie',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;
const chart = ref({
  type: 'doughnut',
  data: {
    labels: ['Finalizado', 'Aguardando', 'Em andamento', 'Interrompido', 'Cancelado'],
    datasets: [
      {
        backgroundColor: [secondaryFinished, secondaryWaiting, secondaryRunning, secondaryInterrupted, secondaryCanceled],
        data: [props.data.servicesFinished, props.data.servicesWaiting, props.data.servicesRunning, props.data.servicesInterrupted, props.data.servicesCanceled],
        hoverBorderWidth: 5,
        borderRadius: 5,
      },
    ],
  },
  options: {
    animation: {
      animateScale: true,
      animateRotate: true,
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem) {
          return tooltipItem.yLabel;
        },
      },
    },
  },
});

watch(
  () => props,
  () => {
    chart.value.data.datasets[0].data = [
      props.data.servicesFinished,
      props.data.servicesWaiting,
      props.data.servicesRunning,
      props.data.servicesInterrupted,
      props.data.servicesCanceled,
    ];
  }
);

onMounted(() => {
  setInterval(() => {
    chart.value.data.datasets[0].data[0] += 3;
    chart.value.data.datasets[0].data[1] += 2;
    chart.value.data.datasets[0].data[2] += 1;
  }, 2000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Vue3ChartJs), _normalizeProps(_guardReactiveProps({ ...chart.value })), null, 16)
    ]),
    _hoisted_3
  ]))
}
}

})